import React from 'react'
import _ from 'underscore'
import { CheckboxSelect } from '@atlaskit/select'
import xtend from 'xtend'
import getPathValue from '../../../utils/getPathValue'

const DependencySelect = props => {
  const { pref, value, preferenceName, storeEdits, allPreferences, activeTab, edits} = props
  if (!value || (!value && !value.length)) {
    storeEdits([])
    value = []
  }

  const handleChange = selected => {
    storeEdits(selected.map(opt => opt.value))
  }

  const dependedPreference = getPathValue(pref.dependsOn, allPreferences)
  if (dependedPreference && dependedPreference.dependencyManifest) {
    let currentValue = dependedPreference.value
    const editKey = pref.dependsOn.split('.')[pref.dependsOn.split('.').length - 1]
    if (!!edits.preferences[editKey]) {
      // the depended preference was edited
      currentValue = edits.preferences[editKey]
    }
    const options = dependedPreference.dependencyManifest[currentValue]
    if (options) {
      return <CheckboxSelect
        className="category-select"
        options={options.map(createOption)}
        placeholder="Options"
        value={value.map(createOption)}
        onChange={selected => handleChange(selected)}
      />
    }
  }
  return <div>No Options</div>
}

const createOption = str => {
  return {label: str, value: str}
}

export default DependencySelect
